import React from 'react';
import { View, Text } from 'react-native';
import { Controller } from 'react-hook-form';
import { useTheme } from '@react-navigation/native';
import CustomCheckbox from '../CustomCheckbox/CustomCheckbox';

const CustomControlledCheckbox = ({
    control,
    name,
    label,
    rules,
    fontSize,
    defaultValue = false,
}) => {

    const { colors } = useTheme();

    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            defaultValue={defaultValue}
            render={({ field: { value, onChange }, fieldState: { error } }) => (
                <View>
                    <CustomCheckbox
                        label={label}
                        value={!!value}
                        onValueChange={onChange}
                        fontSize={fontSize}
                    />
                    {error && (
                        <Text
                            style={{
                                color: colors.error ?? colors.notification,
                                fontSize: 12,
                                marginHorizontal: 10,
                                marginTop: 2,
                            }}
                        >
                            {error.message}
                        </Text>
                    )}
                </View>
            )}
        />
    );
};

export default CustomControlledCheckbox;